import './tokens/dist/variables.css'

// Import specific components from InputGroup2RadioButtonsSet to avoid duplicate RadioOption export
import type { RadioOption } from './components/InputGroup2RadioButtonsSet/InputGroup2RadioButtonsSet'
import { InputGroup2RadioButtonsSet } from './components/InputGroup2RadioButtonsSet/InputGroup2RadioButtonsSet'

export * from './tokens/dist/tokens'

export * from './components/Accordion/Accordion'
export * from './components/AlertSticky/AlertSticky'
export * from './components/AlertToast/AlertToast'
export * from './components/Avatar/Avatar'
export * from './components/Badge/Badge'
export * from './components/Breadcrumb/Breadcrumb'
export * from './components/Button/Button'
export * from './components/Calendar/Calendar'
export * from './components/Card/Card'
export * from './components/ChartPie/ChartPie'
export * from './components/Checkbox'
export * from './components/Chip/Chip'
export * from './components/Divider/Divider'
export * from './components/Dropdown'
export * from './components/DropdownItem'
export * from './components/Filter'
export * from './components/Footer'
export * from './components/Header'
export * from './components/Icons'
export * from './components/InputDropDown'
export { InputGroup2RadioButtonsSet, RadioOption }
export * from './components/InputGroup3RadioButtonsSet'
export * from './components/InputGroup3RadioButtonsText'
export * from './components/InputImageArea/InputImageArea'
export * from './components/InputSearch/InputSearch'
export * from './components/InputTextArea/InputTextArea'
export * from './components/InputTextField/InputTextField'
export * from './components/Link/Link'
export * from './components/Modal/Modal'
export * from './components/RadioButton'
export * from './components/ScrollBar'
export * from './components/Spinner/Spinner'
export * from './components/Switch/Switch'
export * from './components/Tabs/Tabs'
export * from './components/Tags/Tags'
export * from './components/Tooltip/Tooltip'
export * from './components/Typography/Typography'
export * from './components/InputSelect'
export * from './components/AxisTable/axisTable'
export interface DesignTokensConfig {
  prefix?: string
  useCustomProperties?: boolean
}

export function configureDesignTokens(config: DesignTokensConfig = {}): void {
  console.log('Design tokens configured with:', config)
}
